// extracted by mini-css-extract-plugin
export var BtnMenu = "BtnMenu-module--BtnMenu--vDhw7";
export var aniSpin = "BtnMenu-module--ani-spin--SvBaH";
export var close = "BtnMenu-module--close--2T-7f";
export var close__line = "BtnMenu-module--close__line--rGoU0";
export var menu = "BtnMenu-module--menu--eL6Oe";
export var menu__line = "BtnMenu-module--menu__line--iAPZt";